export default __webpack_public_path__ + "fonts/Gotham-Medium.5c5f3eee8482203a8e4954c29ffe81be.eot";